import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/',
)({
  beforeLoad: ({ params }) =>
    redirect({
      params,
      to: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview',
    }),
});
